import React from 'react';
import { bool, func } from 'prop-types';
import { reduxForm } from 'redux-form';
import Radium from 'radium';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton } from '@widergy/energy-ui';

import AuthFormBox from 'app/components/AuthFormBox';
import { message } from 'utils/stringUtils';
import { SIGNUP_USER_REGISTER } from 'constants/reduxForms';

import ReturnToSignIn from '../ReturnToSignIn';

import UserRegister from './layout';
import stylesJS from './styles';
import styles from './styles.module.scss';

function UserRegisterContainer({ handleSubmit, loading, submitFailed, invalid }) {
  return (
    <form onSubmit={handleSubmit} onKeyDown={handleKeyDown(handleSubmit)} style={stylesJS.container}>
      <AuthFormBox title={message('Signup:registerYourEmail')}>
        <UserRegister onKeyDown={handleKeyDown} loading={loading} />
      </AuthFormBox>
      {!loading && [
        <UTButton
          uppercase
          disabled={submitFailed && invalid}
          key="submit"
          className={styles.submit}
          type="submit"
        >
          {message('Signup:signUp')}
        </UTButton>,
        <ReturnToSignIn key="signout" />
      ]}
    </form>
  );
}

UserRegisterContainer.propTypes = {
  handleSubmit: func.isRequired,
  loading: bool,
  submitFailed: bool,
  invalid: bool
};

export default reduxForm({ form: SIGNUP_USER_REGISTER })(Radium(UserRegisterContainer));
